import { Component, Input, OnInit } from '@angular/core';
import { DashboardService } from 'src/app/services/dashboard.service';
import { GoogleAnalyticsEventsService } from 'src/app/services/google-analytics-events.service';

@Component({
  selector: 'app-customer-accordian',
  templateUrl: './customer-accordian.component.html',
  styleUrls: ['./customer-accordian.component.scss']
})
export class CustomerAccordianComponent implements OnInit {
  @Input() customer;
  @Input() index = 0
  showDetail = false;
  @Input() fromDialog = false;
  @Input() selectedCustomerID = null;
  constructor(private dashboardService: DashboardService,
              private googleAnalyticsEventsService: GoogleAnalyticsEventsService) { }

  ngOnInit(): void {
    this.init()
  }

  init() {
    if (this.customer.actions && this.dashboardService.filterValue === 'all') {
      var obj = this.getCount(this.customer.actions)
      // this.customer.alerts_count = obj.red_flag;
      // this.customer.alerts_count1 = obj.yellow_flag;
    }
  }
  getCount(dataList) {
    let total_urgent_count = 0;
    let total_warning_count = 0;
    total_urgent_count = dataList["system_errors"].urgent_count + dataList["maintenances"].service_maintenances.urgent_count +
      dataList["maintenances"].user_maintenances.urgent_count +
      dataList["firmware_updates"].urgent_count +
      dataList["targeted_actions"].urgent_count;
    total_warning_count = dataList["system_errors"].warning_count + dataList["maintenances"].service_maintenances.warning_count +
      dataList["maintenances"].user_maintenances.warning_count +
      dataList["firmware_updates"].warning_count +
      dataList["targeted_actions"].warning_count;
    var obj = {
      red_flag: total_urgent_count,
      yellow_flag: total_warning_count
    }
    return obj;
  }


  togglePanel(index) {
    this.showDetail = !this.showDetail;
    if(this.fromDialog) return
    this.googleAnalyticsEventsService.emitEvent('reseller-portal', `Customer row clicked`, 'from dashboard proactive action card', null)
    this.dashboardService.showMoreProactiveLAlerts(this.customer)
  }

  accordianClass(customer) { 
    if(customer?.customer_name) {
      if(customer?.alerts_count > 0 && customer?.alerts_count1 > 0 && customer?.low_ink_count > 0) {
        return 'width222'
      } else if((customer?.alerts_count > 0 && customer?.alerts_count1 > 0) ||
                customer?.alerts_count > 0 && customer?.low_ink_count > 0 ||
                customer?.low_ink_count > 0 && customer?.alerts_count1 > 0) {
        return 'width2'
      } else {
        return 'width22'
      }
    } else if(customer?.newPrinterName) {
      if(customer?.alerts_count > 0 && customer?.alerts_count1 > 0 && customer?.low_ink_count > 0) {
        return 'width111'
      }else if((customer?.alerts_count > 0 && customer?.alerts_count1 > 0) ||
        customer?.alerts_count > 0 && customer?.low_ink_count > 0 ||
        customer?.low_ink_count > 0 && customer?.alerts_count1 > 0) {
        return 'width1'
      } else {
        return 'width11'
      }
    }
  }

}
